var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row flex-wrap"},_vm._l((_vm.data),function(good,index){return _c('ServiceItem',{key:index,attrs:{"info":good,"index":index + 1,"unitMap":_vm.unitMap}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }